/** Public site identity — replace SITE_ORIGIN before production deploy. */
export const SITE_NAME = 'Screen Detect'
export const SITE_NAME_ZH = '屏幕鸟'
export const SITE_ORIGIN = 'https://s.zzke.vip'
export const SITE_VERSION = '0.4.0'
export const DEFAULT_LOCALE = 'en'
export const SUPPORTED_LOCALES = ['zh-CN', 'zh-TW', 'en', 'ja'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]
